module.exports = __webpack_public_path__ + "static/Summetime-1330ea45344ec9db5a38cba78c9b793b.wav";